'use strict';


module.exports = {
    getDistance: getDistance,
    getNormalizedVector: getNormalizedVector,
    isAbove: isAbove,
};

function getDistance(a, b) {

    var dx = b.x - a.x
    var dy = b.y - a.y

    return Math.sqrt(dx * dx + dy * dy);
}

function getNormalizedVector(a, b, distance) {
    distance = distance || getDistance(a, b);

    var dx = b.x - a.x
    var dy = b.y - a.y

    return {
        x: dx / distance,
        y: dy / distance,
    };
}

function isAbove(x1, y1, x2, y2, x, y) {

    var dx = x2 - x1;
    var dy = y2 - y1;

    // cross product
    var d = (x - x1) * dy - (y - y1) * dx;

    return d < 0;
}
